export default __webpack_public_path__ + "static/media/Perspectiva_front.410b047a.png";